'use client';

import { ReactNode } from 'react';

import {
    SegmentControlItem,
    SegmentControl as SegmentControlTrilogy,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
} from '@bytel/trilogy-react';

export type SegmentControlItemType = {
    key: string;
    title: ReactNode;
    subtitle?: string;
    onClick?: () => void;
    className?: string;
    active?: boolean;
    disabled?: boolean;
};

interface SegmentControlProps {
    items: SegmentControlItemType[];
    defaultActiveKey?: string;
}

export function SegmentControl({ items, defaultActiveKey }: Readonly<SegmentControlProps>) {
    return (
        <SegmentControlTrilogy>
            {items.map(({ key, onClick, className = '', title, subtitle, active, disabled = false }) => (
                <SegmentControlItem
                    key={key}
                    active={typeof active !== 'undefined' ? active : defaultActiveKey === key}
                    className={className}
                    onClick={onClick}
                    disabled={disabled}
                >
                    {title}
                    {subtitle && (
                        <>
                            <Spacer size={SpacerSize.ONE} />
                            <Text level={TextLevels.THREE}>{subtitle}</Text>
                        </>
                    )}
                </SegmentControlItem>
            ))}
        </SegmentControlTrilogy>
    );
}
